import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=89562762&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=89562762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89562762",
  null
  
)

export default component.exports